import { WalletTypeEnum } from '@/context/types/Wallet';
import { EnumValues } from '@/services/types/EnumValues';

export const WalletEligibilityStateEnum = {
  PAY: 'PAY',
  TRANSFER: 'TRANSFER'
} as const;
export type TWalletEligibilityState = EnumValues<typeof WalletEligibilityStateEnum>;

const WALLET_ELIGIBILITY_RULES: Record<TWalletEligibilityState, WalletTypeEnum[]> = {
  [WalletEligibilityStateEnum.PAY]: [WalletTypeEnum.EVERYDAY],
  [WalletEligibilityStateEnum.TRANSFER]: [WalletTypeEnum.EVERYDAY, WalletTypeEnum.GROWTH]
};

export const isWalletTypeEligible = (
  walletType: WalletTypeEnum | undefined,
  state: TWalletEligibilityState
): boolean => !!walletType && WALLET_ELIGIBILITY_RULES[state].includes(walletType);
